import BaseService from '../baseService'
import { QueryBuilder } from '../utils'

export class SupportingDocumentService extends BaseService {
  create(
    classification,
    fileName,
    fileType,
    source,
    loanApplicationId,
    references,
    logDownload
  ) {
    const config = {
      json: {
        classification,
        fileName,
        fileType,
        source,
        loanApplicationId,
        references,
        logDownload,
      },
    }

    return this.client.post('documents', config).json()
  }

  list(loanApplicationId) {
    const queryParams = QueryBuilder()
      .setParam('loanApplicationId', loanApplicationId)
      .build()

    return this.client.get(`documents?${queryParams}`).json()
  }
}
